import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { SerialNoStatusResponse, SerialNoStatusResponseList } from '../../custom-stock-potection.models';
import { getStockProtectionDetails, updateSerialNumbers, updateSerialNumbersFailure } from '../../store/custom-stock-protection.actions';
import { CustomStockProtectionState } from '../../store/custom-stock-protection.reducer';
import { errorStockProtectionDetails, selectStockProtectionDetails } from '../../store/custom-stock-protection.selectors';

@Component({
    selector: 'app-custom-stock-protection-details',
    templateUrl: './custom-stock-protection-details.component.html',
    styleUrls: ['./custom-stock-protection-details.component.scss'],
    standalone: false
})
export class CustomStockProtectionDetailsComponent implements OnInit {

  @Input() processNumber: string;
  @Input() productCode: string;
  @Input() inactive: boolean;
  @ViewChild('updateForm') updateForm: NgForm;

  stockProtectionDetails$: Observable<SerialNoStatusResponseList>  =
  this.store.select(selectStockProtectionDetails);
  errorOverview$: Observable<Error> = this.store.select(errorStockProtectionDetails);

  stockProtectionDetails: SerialNoStatusResponseList;
  serialNumbersData: SerialNoStatusResponse[];
  errorOverview: Error;
  addRow: boolean = false;
  newSerialNumber: string;

  sortDirection: string = 'asc';
  compare = (v1: string | number | Date, v2: string | number | Date) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  constructor(public modal: NgbActiveModal,
    private store: Store<CustomStockProtectionState>,
    private translation: TranslationService,
    private messageService: GlobalMessageService) { }

  ngOnInit(): void {

    this.handleAddRow();
    this.getStockProtectionDetails();

    this.stockProtectionDetails$
      .pipe(
        filter((stockProtectionDetails) => stockProtectionDetails != null),
        tap((stockProtectionDetails) => {
          this.stockProtectionDetails = stockProtectionDetails;
          this.serialNumbersData = [...stockProtectionDetails.responses];
          this.sort();
        })
      )
      .subscribe();
     
    this.errorOverview$
      .pipe(
        filter((error) => error != null),
        tap((error) => {
          this.errorOverview = error;
        }),
        switchMap(() => this.translation.translate('customStockProtection.error')),
        tap((text) => {
          this.messageService.add(text, GlobalMessageType.MSG_TYPE_ERROR);
        })
      )
      .subscribe();
    
  }

  getStockProtectionDetails(): void {
    this.stockProtectionDetails = null;
    this.serialNumbersData = null;
    this.errorOverview = null;
    this.store.dispatch(getStockProtectionDetails(
      {
        processNumber: this.processNumber,
      }
    ));
  }

  sort(): void {
    this.serialNumbersData = [...this.stockProtectionDetails.responses].sort((a, b) => {
       const res = this.compare(
         parseInt(a.serialNumber),
         parseInt(b.serialNumber)
       );
       return this.sortDirection === 'asc' ? res : -res;   
   });
  }

  onDeleteSerialNumber(index: number){
      this.serialNumbersData.splice(index,1);
  }
 
  handleAddRow(): void {
    if(!this.inactive){
      this.addRow = true;
    }
  }

  onAddSerialNumber(): void{
    var newSerialNumberData = {} as SerialNoStatusResponse;
    newSerialNumberData.serialNumber = this.updateForm.value.newSerialNumber;
    this.serialNumbersData.push(newSerialNumberData);
    this.newSerialNumber = " ";
  }

  onSave(): void{
    this.onUpdate();
    this.modal.close();
  }

  onUpdate(): void{
    var count = this.serialNumbersData.length;
    var newSerialNumbers: Array<string> = new Array();
    for (let i = 0; i < count; i++) {
      newSerialNumbers.push(this.updateForm.controls['updateSerialNumber[' + i + ']']
      .value);
    }
    this.updateSerialNumbers(newSerialNumbers);
  }

  updateSerialNumbers(newSerialNumbers: Array<string>): void{
    this.stockProtectionDetails = null;
    this.serialNumbersData = null;
    this.errorOverview = null;
    this.store.dispatch(updateSerialNumbers({
      processNumber: this.processNumber,
      serialNumbers: newSerialNumbers
    }));
  }

}
